import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state:{
      addUserStatus:false,
      userName:'',
      parameterList:[],
      weekList:[],
      getDayList:[],
      getSeasonInform:'',
      userList:[],
      ifShowMessage:false,
      store:[],
      userLength:0,
      seasonchecked:{},
  },
  mutations:{
      openAddUser(state){
        state.addUserStatus = true;
      },
      closeAddUser(state){
        state.addUserStatus = false;
      },
      getParameterList(state,list){
        state.parameterList = list;
      },
      getWeekList(state,list){
        state.weekList = list;
      },
      setDayList(state,list){
        state.getDayList = list;
      },
      getSeason(state,season){
        state.getSeasonInform = season;
      },
      getUserList(state,list){
        state.userList = list;
      },
      getIfShowMessage(state,ifshow){
        state.ifShowMessage = ifshow;
      },
      getStoreList(state,list){
        state.store = list;
      },
      getUserLength(state,number){
        state.userLength = number;
      },
      getCheckedSeason(state,season){
        state.seasonchecked = season;
      }
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js